import { Component } from '@angular/core';
import { Globals } from '../../services/globals';

@Component({
  selector: 'view-more',
  templateUrl: './view-more.html',
  styleUrls: ['./view-more.scss'],
})

export class ViewMorePage {

  /**
   * 센터연결 버튼의 링크 타입
   */
  private static LINK_PRE: string = 'tel:';

  constructor(private $g: Globals) {}

  /**
   * 센터 전화 연결 링크 반환
   */
  getCenterCall(): string {
    return ViewMorePage.LINK_PRE + this.$g.child.centerPhone;
  }
}
